import InvoicePdf from 'components/Invoice/InvoicePdf';
import DefaultHeader from 'components/UI/V3/DefaultHeader/DefaultHeader';
import styles from './InvoiceContainer.module.scss';

interface InvoiceContainerProps {
    pdfUrl: string;
    invoiceNumber: number;
    onBackInvoice: () => void;
}

const InvoiceContainer = ({ pdfUrl, onBackInvoice, invoiceNumber }: InvoiceContainerProps) => {
    return (
        <div className={styles.invoiceContainer}>
            <DefaultHeader
                title={`Invoice #${invoiceNumber}`}
                onBack={onBackInvoice}
            />
            <InvoicePdf url={pdfUrl} />
        </div>
    );
};

export default InvoiceContainer;
